const ProjectDetailComponent = ({project}) => {
    return ( 
        <div className="bg-primary w-full h-full flex flex-col md:flex-row gap-[30px] lg:gap-[80px] px-[30px] py-[100px] md:py-[150px]">
            <a target="_blank" href={project.projectLink} className="md:basis-[55%] lg:basis-[60%] h-[300px] md:h-[600px] lg:h-[650px] rounded-[30px] lg:rounded-[60px] bg-cover bg-center bg-no-repeat shadow-lg shadow-red cursor-pointer " style={{backgroundImage: `url(${project.imgPath})`}}></a>
            <div className="md:basis-[45%] lg:basis-[40%] justify-center flex flex-col gap-[20px]">
                <h1 className="text-[35px] font-[600] font-montserrat text-accent">{project.title}</h1>
                <p className="text-[16px] lg:text-[18px] text-ash font-poppins leading-[27px] tracking-[0.05rem]">{project.longDesc}</p>
                <div>
                    <h1 className="text-[24px] font-[600] font-montserrat text-text">Company</h1>
                    <p className="text-[16px] lg:text-[18px] tracking-[0.1rem] text-ash font-poppins mt-2">{project.companyName}</p>
                </div>
                <div>
                    <h1 className="text-[24px] font-[600] font-montserrat text-text">Role</h1>
                    <p className="text-[16px] lg:text-[18px] tracking-[0.1rem] text-ash font-poppins mt-2">{project.role}</p>
                </div>
            </div>
        </div>
     );
}
 
export default ProjectDetailComponent;